import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringArrayToString',
    standalone: false,
})
export class StringArrayToStringPipe implements PipeTransform {
    transform(value: string[]) {
        return value?.join(' ') || '';
    }
}
